export const heroMockup = {
  src: 'https://cdn.magicpatterns.com/uploads/2KwtZBg6yND5PE9gojhpYN/DPS23-mockup-6-tomos-pista-3x2.png',
  alt: 'The six Figure Skating Class Ready volumes fanned out on the rink boards: First Glides, Edges & Crossovers, Turns & Footwork, Jumps & Spins, The Season Show and Programs & Season Close',
}
